import { ParseDMYwSlashes } from 'helpers/DateHelpers';

export const isEmptyOrSpaces = str =>
	str === undefined || str === null || str.toString().match(/^ *$/) !== null;

export const required = value =>
	isEmptyOrSpaces(value) ? 'Required' : undefined;

export const requiredDropdown = value => {
	if (isEmptyOrSpaces(value) || value === 'validationError') {
		return 'Required';
	}
	return undefined;
};

export const percentage = value => {
	if (value === undefined) return undefined;

	if (isNaN(value)) {
		return 'Must be a number';
	}

	if (parseInt(value, 10) >= 101 || parseInt(value, 10) < 0) {
		return 'Not a valid Percentage';
	}
	return undefined;
};

export const dateValid = value => {
	if (isEmptyOrSpaces(value)) {
		return undefined;
	}

	if (value.length !== 10) {
		return 'Too short (DD/MM/YYYY)';
	}

	if (value[2] !== '/' || value[5] !== '/') {
		return 'Invalid Format (DD/MM/YYYY)';
	}

	let parsed = ParseDMYwSlashes(value);

	if (parsed.toString().includes('Invalid Date')) {
		return 'Invalid Date (DD/MM/YYYY)';
	}

	return undefined;
};

export const monthDayValid = value => {
	if (isEmptyOrSpaces(value)) return undefined;

	if (value.length !== 5) {
		return 'Invalid Format (DD/MM)';
	}

	if (value[2] !== '/') {
		return 'Invalid Format (DD/MM)';
	}

	let parsed = ParseDMYwSlashes(`${value}/2018`);

	if (parsed.toString().includes('Invalid Date')) {
		return 'Invalid Date';
	}

	return undefined;
};

export const number = value => {
	if (isEmptyOrSpaces(value)) return undefined;

	return isNaN(value.toString()) ? 'Must be a number' : undefined;
};

export const saId = value => {
	if (isEmptyOrSpaces(value)) return undefined;
	if (value.length !== 13) {
		return 'Not a Valid SA ID';
	}

	// apply Luhn formula for check-digits
	let initTotal = 0;
	let checkSum = 0;
	let multiplier = 1;
	for (var i = 0; i < 13; ++i) {
		initTotal = parseInt(value.charAt(i), 10) * multiplier;
		if (initTotal > 9) {
			initTotal =
				parseInt(initTotal.toString().charAt(0), 10) +
				parseInt(initTotal.toString().charAt(1), 10);
		}
		checkSum = checkSum + initTotal;
		multiplier = multiplier % 2 === 0 ? 1 : 2;
	}

	if (checkSum % 10 !== 0) {
		return 'Not a Valid SA ID';
	}

	return undefined;
};

export const email = value => {
	if (isEmptyOrSpaces(value)) return undefined;

	let mailformat = /\S+@\S+\.\S+/;

	return value.match(mailformat) ? undefined : 'Not a Valid Email Addres';
};



// WEBPACK FOOTER //
// ./src/helpers/ValidationHelpers.js